// Who counts as a member in the browser: the ID token's
// `custom:isSubscribed` equals the string "true". That attribute is written
// only by the live Stripe webhook (Cognito admin API); the app client cannot
// write it. Never localStorage or a client flag.
//
// This drives UX only (the /members route guard). The browser can be lied
// to, so the members data API verifies the ID token server-side and checks
// the same attribute before it signs any link - that is the security control.

export const SUBSCRIBED_CLAIM = 'custom:isSubscribed';

export const ACCESS = Object.freeze({
  LOADING: 'loading',
  SIGNED_OUT: 'signed-out',
  NON_MEMBER: 'non-member',
  MEMBER: 'member',
});

/**
 * @param {{ expired?: boolean, profile?: Record<string, unknown> } | null | undefined} user
 *   an oidc-client-ts User; `profile` holds the ID token claims
 * @returns {boolean}
 */
export const isMember = (user) => {
  if (!user || user.expired) return false;
  return user.profile?.[SUBSCRIBED_CLAIM] === 'true';
};

/**
 * @param {{ isLoading: boolean, isAuthenticated: boolean, user?: object | null }} auth
 *   the react-oidc-context auth state
 * @returns {'loading' | 'signed-out' | 'non-member' | 'member'}
 */
export const memberAccess = (auth) => {
  if (auth.isLoading) return ACCESS.LOADING;
  if (!auth.isAuthenticated || !auth.user || auth.user.expired) return ACCESS.SIGNED_OUT;
  return isMember(auth.user) ? ACCESS.MEMBER : ACCESS.NON_MEMBER;
};
